/*========================================
    Splideの初期化
    ========================================*/
document.addEventListener("DOMContentLoaded", function () {
  // Splide01の初期化
  const splide01Element = document.querySelector("#splide01");
  if (splide01Element) {
    const splide01 = new Splide(splide01Element, {
      type: "loop",
      pauseOnHover: false,
      pauseOnFocus: false,
      fixedWidth: "15.65rem",
      gap: "1rem",
      pagination: false,
      arrows: false,
      perMove: 1,
      perPage: 1,
      breakpoints: {
        768: {
          fixedWidth: "14.65rem",
          gap: "0.625rem",
        },
      },
    });

    const bar = document.querySelector("#splide01 .app__splide-progress-bar");

    if (bar) {
      splide01.on("mounted move", function () {
        const end = splide01.Components.Controller.getEnd() + 1;
        const rate = Math.min((splide01.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      });
    }

    splide01.mount();
  }

  // Splide02の初期化
  const splide02Element = document.querySelector("#splide02");

  if (splide02Element) {
    const splide02 = new Splide(splide02Element, {
      // type: "loop",
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 500,
      fixedWidth: "18rem",
      gap: "1.56rem",
      perMove: 1,
      perPage: 1,
      pagination: false,
      arrows: false,
      drag: "free",
      breakpoints: {
        768: {
          fixedWidth: "16.8rem",
          gap: "1.75rem",
        },
      },
    });

    splide02.on("mounted move resized updated", function () {
      matchSlideTitleHeight();
    });

    splide02.mount();

    function matchSlideTitleHeight() {
      const titles = splide02Element.querySelectorAll(
        ".voice__splide-wrapper .splide__slide-title"
      );

      // 高さリセット
      titles.forEach((title) => {
        title.style.height = "auto";
      });

      // 最大高さを取得
      let maxHeight = 0;
      titles.forEach((title) => {
        const height = title.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // 全てのタイトルに最大高さを適用
      titles.forEach((title) => {
        title.style.height = `${maxHeight}px`;
      });
    }
  }
});

// ページ内リンクのスムーススクロール
// $('a[href*="#"]').on("click", function (event) {
//   const targetId = this.hash;
//   if (targetId) {
//     const targetElement = $(targetId);
//     if (targetElement.length) {
//       event.preventDefault();
//       smoothScrollTo(targetElement);
//       window.history.pushState(null, null, targetId);
//     }
//   }
// });

// ページトップへ戻るボタンのスムーススクロール
jQuery(document).ready(function ($) {
  $(".js-page-top").on("click", function (event) {
    event.preventDefault(); // デフォルトのリンク動作を無効化
    $("html, body").animate({ scrollTop: 0 }, 500); // 500msかけて最上部にスクロール
  });
});

/*========================================
  アコーディオン開閉処理（jQuery＋slideToggle）
========================================*/
jQuery(function ($) {
  $(".js-accordion").on("click", function () {
    const $button = $(this);
    const $region = $button.closest(".shop-block__region");
    const $content = $region.find(".shop-block__area-body");

    // 表示・非表示を切り替える
    $content.stop(true, true).slideToggle(300);
    $button.toggleClass("is-open");
  });
});

/*========================================
  FAQアコーディオン（slideToggle＋details）
========================================*/
jQuery(function ($) {
  $(".js-faq-summary").on("click", function (e) {
    e.preventDefault();

    const $summary = $(this);
    const $details = $summary.closest(".js-faq-item");
    const $content = $details.find(".js-faq-content");

    const isOpen = $details.attr("open");

    if (isOpen) {
      // 先に見た目上の「−→＋」を動かすためにクラスを外す
      $details.removeClass("is-open");

      // slideUp後に open を削除
      $content.stop(true, true).slideUp(300, function () {
        $details.removeAttr("open");
      });
    } else {
      // open 属性は後から付与
      $details.attr("open", true);

      // アニメ用クラスを先に付けて「＋→−」を即時に反映
      $details.addClass("is-open");

      // コンテンツを開く
      $content.stop(true, true).slideDown(300);
    }
  });
});

/*========================================
  マウスとキーボードの操作状態に応じてクラスを付与
========================================*/
document.addEventListener("mousedown", () => {
  document.body.classList.add("using-mouse");
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Tab") {
    document.body.classList.remove("using-mouse");
  }
});

/*========================================
  ページ内すべてのvideoに再生・停止ボタンを対応させる
========================================*/
jQuery(function ($) {
  $("video").each(function (index) {
    const video = this;
    video.controls = false; // コントロールバー非表示

    // 再生ボタン（index番号で対応）
    $(`.play-button:eq(${index})`).on("click", function () {
      video.play();
    });

    // 停止ボタン（index番号で対応）
    $(`.pause-button:eq(${index})`).on("click", function () {
      video.pause();
    });
  });
});

/*========================================
  ローディングアニメーション
========================================*/
// HTML要素の取得
const progressCircle = document.getElementById("progressCircle");
const percentageText = document.getElementById("percentageText");
const completionMessage = document.getElementById("completionMessage");

// アニメーションの設定値
let currentPercentage = 0; // 現在のパーセンテージ
const increment = 1; // 1回の更新で増加するパーセンテージ
const animationInterval = 10; // アニメーションの更新間隔 (ミリ秒)。小さいほど速い。
const completionMessageDuration = 2000; // 同期完了メッセージの表示時間 (ミリ秒)
const restartDelay = 500; // アニメーション再開までの遅延時間 (ミリ秒)

// 進捗を更新する関数
function updateProgress() {
  currentPercentage += increment; // パーセンテージを増加

  if (currentPercentage <= 100) {
    // 100%以下の場合、進捗を更新
    percentageText.textContent = `${currentPercentage}%`;
    progressCircle.style.background = `conic-gradient(#4CAF50 ${currentPercentage}%, #e0e0e0 ${currentPercentage}%)`;

    // 次の更新をスケジュール
    setTimeout(updateProgress, animationInterval);
  } else {
    // 100%に達した場合
    percentageText.style.opacity = "0"; // パーセンテージテキストを非表示
    completionMessage.classList.add("show"); // 同期完了メッセージを表示

    // 一定時間後にメッセージを非表示にし、アニメーションをリセット
    setTimeout(() => {
      completionMessage.classList.remove("show"); // 同期完了メッセージを非表示

      // メッセージが完全に消えるのを待ってからパーセンテージを再表示し、リセット処理
      setTimeout(() => {
        percentageText.style.opacity = "1"; // パーセンテージテキストを再表示
        currentPercentage = 0; // パーセンテージをリセット
        percentageText.textContent = `${currentPercentage}%`; // テキストを0%に
        progressCircle.style.background = `conic-gradient(#4CAF50 0%, #e0e0e0 0%)`; // 円を初期状態に

        // 少し遅れてアニメーションを再開
        setTimeout(updateProgress, restartDelay);
      }, 300); // completionMessageのtransition時間（0.3s）に合わせる
    }, completionMessageDuration);
  }
}

// アニメーションを開始
updateProgress();

/*========================================
  グラフアニメーション
========================================*/
// Canvas要素と2Dコンテキストを取得
const canvas = document.getElementById("healthGraph");
const ctx = canvas.getContext("2d");
const container = document.querySelector(".graph-container");
const scoreDisplayElement = document.getElementById("score-display");

// グラフのデータポイント (過去6日 + 今日)
// スコアは0から100の範囲
const scores = [70, 75, 65, 80, 70, 85, 94];
const todayScore = scores[scores.length - 1];

// グラフのスタイル設定
const graphColor = "#00BFFF"; // ネオンブルー
const glowColor = "rgba(0, 191, 255, 0.7)"; // グローの色
const axisColor = "#555"; // 軸の色
// const textColor = '#ccc'; // テキストの色 (ラベルを消すので不要に)
const pointRadius = 3; // データポイントの円の半径

let animationProgress = 0; // アニメーションの進行度 (0 to 1)
const animationSpeed = 0.007; // アニメーションの速度
const loopDelay = 3000; // ループ再開までの遅延時間 (ミリ秒)
let loopTimeoutId = null; // ループ再開用のsetTimeoutのID

// グラフの寸法関連の変数をグローバルスコープに
let canvasPadding, graphWidth, graphHeight, pointDistanceX, scoreScaleY;

function setupDimensions() {
  // Canvasの解像度をデバイスピクセル比に合わせて設定
  canvas.width = container.clientWidth * window.devicePixelRatio;
  canvas.height = container.clientHeight * window.devicePixelRatio;
  ctx.scale(window.devicePixelRatio, window.devicePixelRatio); // スケーリング

  // グラフの内部パディングと寸法
  canvasPadding = { top: 50, right: 20, bottom: 20, left: 20 }; // 左右下のパディングを調整
  graphWidth = container.clientWidth - canvasPadding.left - canvasPadding.right;
  graphHeight =
    container.clientHeight - canvasPadding.top - canvasPadding.bottom;

  // X軸のポイント間の距離 (scoresが2つ以上ある場合)
  pointDistanceX =
    scores.length > 1 ? graphWidth / (scores.length - 1) : graphWidth;
  // Y軸のスコアのスケーリング (0-100のスコアをグラフの高さにマッピング)
  scoreScaleY = graphHeight / 100;
}

// 軸を描画する関数
function drawAxes() {
  ctx.clearRect(
    0,
    0,
    canvas.width / window.devicePixelRatio,
    canvas.height / window.devicePixelRatio
  ); // Canvasをクリア
  ctx.strokeStyle = axisColor;
  ctx.lineWidth = 1;
  // ctx.font = `${12 * window.devicePixelRatio}px Arial`; // ラベルを消すのでフォント設定は不要に
  // ctx.fillStyle = textColor; // ラベルを消すのでフィルスタイル設定は不要に

  // Y軸 (スコア) - 線のみ描画
  ctx.beginPath();
  ctx.moveTo(canvasPadding.left, canvasPadding.top);
  ctx.lineTo(canvasPadding.left, canvasPadding.top + graphHeight);
  ctx.stroke();

  // Y軸の目盛り線のみ描画 (ラベルは描画しない)
  for (let i = 0; i <= 4; i++) {
    const scoreValue = i * 25;
    const yPos = canvasPadding.top + graphHeight - scoreValue * scoreScaleY;
    // ctx.fillText(scoreValue, canvasPadding.left - 30 * window.devicePixelRatio, yPos + (4 * window.devicePixelRatio)); // Y軸ラベル削除
    ctx.beginPath();
    ctx.moveTo(canvasPadding.left - 5 * window.devicePixelRatio, yPos);
    ctx.lineTo(canvasPadding.left, yPos);
    ctx.stroke();
  }

  // X軸 (日付) - 線のみ描画
  ctx.beginPath();
  ctx.moveTo(canvasPadding.left, canvasPadding.top + graphHeight);
  ctx.lineTo(canvasPadding.left + graphWidth, canvasPadding.top + graphHeight);
  ctx.stroke();

  // X軸のラベルは描画しない
  // const days = ["-6日", "-5日", "-4日", "-3日", "-2日", "-1日", "今日"];
  // if (scores.length === days.length) {
  //     days.forEach((day, index) => {
  //         const xPos = canvasPadding.left + index * pointDistanceX;
  //         ctx.textAlign = 'center';
  //         // ctx.fillText(day, xPos, canvasPadding.top + graphHeight + (20 * window.devicePixelRatio)); // X軸ラベル削除
  //     });
  // }
}

// 滑らかな線グラフを描画する関数
function drawLineGraph() {
  if (scores.length < 2) return; // 描画するのに最低2点は必要

  ctx.beginPath();
  ctx.lineWidth = 2 * window.devicePixelRatio; // 線の太さもスケーリング
  ctx.strokeStyle = graphColor;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";

  // ネオン効果 (グロー)
  ctx.shadowBlur = 15 * window.devicePixelRatio;
  ctx.shadowColor = glowColor;

  const totalAnimatedSegments = animationProgress * (scores.length - 1);

  const startX = canvasPadding.left;
  const startY = canvasPadding.top + graphHeight - scores[0] * scoreScaleY;
  ctx.moveTo(startX, startY);

  for (let i = 0; i < scores.length - 1; i++) {
    const currentSegmentProgress = totalAnimatedSegments - i;

    if (currentSegmentProgress <= 0) break; // このセグメントはまだ描画しない

    const x1 = canvasPadding.left + i * pointDistanceX;
    const y1 = canvasPadding.top + graphHeight - scores[i] * scoreScaleY;

    let x2, y2;
    if (currentSegmentProgress >= 1) {
      // このセグメントは完全に描画
      x2 = canvasPadding.left + (i + 1) * pointDistanceX;
      y2 = canvasPadding.top + graphHeight - scores[i + 1] * scoreScaleY;
    } else {
      // このセグメントは部分的に描画 (現在アニメーション中のセグメント)
      x2 = x1 + pointDistanceX * currentSegmentProgress;
      y2 =
        y1 +
        (canvasPadding.top + graphHeight - scores[i + 1] * scoreScaleY - y1) *
          currentSegmentProgress;
    }
    ctx.lineTo(x2, y2);
  }
  ctx.stroke();

  // グローをリセット
  ctx.shadowBlur = 0;
  ctx.shadowColor = "transparent";
}

// データポイントの円を描画する関数
function drawDataPoints() {
  if (scores.length === 0) return;

  const animatedSegments = animationProgress * (scores.length - 1);
  ctx.fillStyle = graphColor;
  ctx.shadowBlur = 10 * window.devicePixelRatio; // ポイントのグロー
  ctx.shadowColor = glowColor;

  for (let i = 0; i < scores.length; i++) {
    if (
      i <= animatedSegments ||
      (i === 0 && animatedSegments >= 0) ||
      animationProgress >= 1
    ) {
      const x = canvasPadding.left + i * pointDistanceX;
      const y = canvasPadding.top + graphHeight - scores[i] * scoreScaleY;

      ctx.beginPath();
      ctx.arc(x, y, pointRadius * window.devicePixelRatio, 0, Math.PI * 2);
      ctx.fill();
    }
    if (animationProgress >= 1 && i === scores.length - 1) {
      const x = canvasPadding.left + i * pointDistanceX;
      const y = canvasPadding.top + graphHeight - scores[i] * scoreScaleY;
      ctx.beginPath();
      ctx.arc(x, y, pointRadius * window.devicePixelRatio, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  ctx.shadowBlur = 0;
  ctx.shadowColor = "transparent";
}

// スコア表示を更新・表示する関数
function showScore() {
  // scoreDisplayElement.textContent = `${todayScore}点`;
  scoreDisplayElement.textContent = `${todayScore}pt`;

  const lastPointX = canvasPadding.left + (scores.length - 1) * pointDistanceX;
  const lastPointY = canvasPadding.top + graphHeight - todayScore * scoreScaleY;

  scoreDisplayElement.style.visibility = "hidden";
  scoreDisplayElement.style.opacity = "1";
  const scoreWidth = scoreDisplayElement.offsetWidth;
  const scoreHeight = scoreDisplayElement.offsetHeight;
  scoreDisplayElement.style.visibility = "visible";
  scoreDisplayElement.style.opacity = "0";

  scoreDisplayElement.style.left = `${lastPointX - scoreWidth / 2}px`;
  scoreDisplayElement.style.top = `${
    lastPointY - scoreHeight - 10 * window.devicePixelRatio
  }px`;

  scoreDisplayElement.style.opacity = "1";
  scoreDisplayElement.style.transform = "translateY(0) scale(1)";
}

// アニメーションループ
function animate() {
  setupDimensions();
  drawAxes();
  drawLineGraph();
  drawDataPoints();

  if (animationProgress < 1) {
    animationProgress += animationSpeed;
    if (animationProgress > 1) animationProgress = 1;
    requestAnimationFrame(animate);
  } else {
    showScore();
    loopTimeoutId = setTimeout(() => {
      animationProgress = 0;
      scoreDisplayElement.style.opacity = "0";
      scoreDisplayElement.style.transform = "translateY(20px) scale(0.5)";
      requestAnimationFrame(animate);
    }, loopDelay);
  }
}

// 初期化とアニメーション開始
requestAnimationFrame(animate);

// ウィンドウリサイズ時の処理
window.addEventListener("resize", () => {
  clearTimeout(loopTimeoutId);
  animationProgress = 0;
  scoreDisplayElement.style.opacity = "0";
  scoreDisplayElement.style.transform = "translateY(20px) scale(0.5)";
  requestAnimationFrame(animate);
});

/*========================================
  「続きを読む」 スライドアコーディオン処理
========================================*/
$(document).ready(function () {
  $(".collaboration__accordion-button").on("click", function () {
    const $accordion = $(this).closest(".collaboration__accordion");
    const $more = $accordion.find(".collaboration__accordion-more");
    const isOpen = $accordion.hasClass("is-open");

    $more.slideToggle(300);
    $accordion.toggleClass("is-open");
    $(this)
      .text(isOpen ? "続きを読む" : "閉じる")
      .attr("aria-expanded", !isOpen);
  });
});
